import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { initTrackers } from './init';
import { onLoggedInRoute, pageView } from './pagView';

import { useAuth } from 'providers/Auth';
import { useToggleV2 } from 'hooks';

export function Tracking() {
  const { isLogged, data } = useAuth();

  const [loaded, loadHandle] = useToggleV2();

  useEffect(() => {
    initTrackers().then(loadHandle.turnOn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (!loaded) return;

    pageView(location.pathname + location.search);

    if (!isLogged) return;

    onLoggedInRoute(data!.user, location.pathname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, data?.user.id, isLogged, loaded]);

  return null;
}
